<template>
  <div class="flex items-center h-full">
    <div class="flex-1 text-left footer-logo-container">
      <slot />
    </div>

    <div class="flex items-center h-12">
      <div v-if="hasMixedSelection">
        Please choose either Ecoventure or Expedition
      </div>
      <div v-else-if="selectedProgrammes.length" class="price-box flex flex-col">
        <currency-context>
          <template v-slot="{ convert }">
            <span
              class="fs-20 font-medium mb-2"
              v-text="convert(totalPrices)"
            ></span>
          </template>
        </currency-context>
        <template v-if="selectedProgrammes.length === 1">
          1 project
        </template>
        <template v-else>
          {{ selectedProgrammes.length }} projects
        </template>
      </div>
      <button v-if="selectedProgrammes.length === 0"
        type="button"
        class="btn btn-primary ml-4" @click="addActivity">
        Add project
      </button>
      <button v-else
        type="button"
        class="btn btn-primary ml-4" @click="addDate">
        {{ bookingCTA }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ZbModal from '../core/ZbModal'
import CurrencyContext from '../core/CurrencyContext';
import {
  ECOVENTURE_CATEGORIES
} from '../../helpers/constants'

export default {
  components: {
    ZbModal,
    CurrencyContext
  },
  computed: {
    ...mapState(['selectedProgrammes', 'formData']),
    hasMixedSelection () {
      const numEcoventures = this.selectedProgrammes.filter(pg => {
        return pg.category === ECOVENTURE_CATEGORIES.ECOVENTURE
      })

      const numExpeditions = this.selectedProgrammes.filter(pg => {
        return pg.category === ECOVENTURE_CATEGORIES.EXPEDITION
      })

      if (numEcoventures.length !== 0 && numExpeditions.length !== 0) {
        return true
      }

      return false
    },
    totalPrices () {
      return this.selectedProgrammes.reduce((agg, item) => {
        return agg + this.getItemPrice(item)
      }, 0)
    },
    bookingCTA () {
      if (!this.formData.date) {
        return 'Select date'
      }

      if (this.formData.guests === '0') {
        return 'Add travelers'
      }

      return 'Your trip'
    }
  },
  methods: {
    getItemPrice (item) {
      if (item.category === ECOVENTURE_CATEGORIES.ECOVENTURE) {
        return item.eco_weekly_price
      }
      else if (item.category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return item.expedition_price
      }

      return 0
    },
    addActivity () {
      $('.projects-link').trigger('click')
    },
    addDate () {
      this.$store.commit('setIsShowingMobileBooking', true)
    }
  }
}
</script>

<style scoped>
.price-box {
  line-height: 100%;
}

.footer-logo-container > img {
  max-height: 48px;
  width: auto;
}
</style>